var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8855 14.9713C21.8754 13.1152 22.7133 11.7142 24.4094 10.6825C23.4604 9.32198 22.0268 8.57346 20.1339 8.42679C18.3419 8.28517 16.3834 9.47371 15.6666 9.47371C14.9094 9.47371 13.173 8.47736 11.81 8.47736C8.99336 8.52288 6 10.728 6 15.2141C6 16.5391 6.2423 17.9081 6.72689 19.3208C7.37301 21.177 9.7051 25.7288 12.1382 25.6529C13.4102 25.6226 14.3087 24.7476 15.9644 24.7476C17.5696 24.7476 18.4025 25.6529 19.8209 25.6529C22.2742 25.6175 24.3842 21.4804 25 19.6192C21.7088 18.0665 21.8855 15.0674 21.8855 14.9713ZM19.0284 6.66675C20.4065 5.02809 20.2803 3.5361 20.2399 3C19.0234 3.07081 17.615 3.82944 16.8124 4.7651C15.9291 5.7665 15.4091 7.00561 15.5202 8.4015C16.8377 8.50265 18.0391 7.82493 19.0284 6.66675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.d580ea7bd95754da378ec25eeedead7e.svg";
export { ForwardRef as ReactComponent };